import './notes-component.css';
import { IconAuditorNotesHeading } from 'jitsi/base/icons/svg';
import { IconAuditorNoteClose } from 'jitsi/base/icons/svg';
import { IconAuditorNoteEdit } from 'jitsi/base/icons/svg';
import { IconAuditorNoteDelete } from 'jitsi/base/icons/svg';
import React, { useState } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { addAuditMessages,setMessageListVisibility } from './actions'
import * as IISightAPI from 'common/helpers/api';

const NoteShowComponent = (props) => {
    return <div className='meeting-auditor-bubble-container'>
        <div className='meeting-auditor-note-title-container'>
            <div className='meeting-auditor-note-title-text'>{props.title}</div>
            <IconAuditorNoteEdit className='meeting-auditor-note-edit-icon' style={{width: '17px',height: '17px',cursor: 'pointer'}} onClick={() => props.setEditNotes([...props.editNotes,props.id])}/>
        </div>
        <div className='meeting-auditor-note-content'>{props.content}</div>
    </div>
}

const NoteEditComponent = (props) => {

    const [noteContent,setNoteContent] = useState(props.content);

    const onSaveNote = async () => {
        const updatedNotes = props.notes.map(note => {
            const n = {...note};
            return n;
        })
        const res = await IISightAPI.updateNote(
            {   
                id: props.note_id,
                meeting_audit_note: {
                    meeting_audit_id: window.APP.meeting_audit_id,
                    note: noteContent
                }

            });
        const { data: body } = res
        if(!body.status)
            return
        updatedNotes.map((note) => {
            if(note.id === props.id) {
                note.content = noteContent;
            }
        })
        props.dispatch(addAuditMessages(updatedNotes))
        props.setEditNotes(props.editNotes.filter(id => id != props.id));
    }

    const onDeleteNote = async () => {
        props.setEditNotes(props.editNotes.filter(id => id != props.id));
        const res = await IISightAPI.deleteNote(
            {
                id: props.note_id
            });
        const { data: body } = res
        if(!body.status)
            return
        props.dispatch(addAuditMessages(props.notes.filter(note => note.id != props.id)));
    }
    return <div className='meeting-auditor-bubble-container'>
        <div className='meeting-auditor-note-title-container'>
            <div className='meeting-auditor-note-title-text'>{props.title}</div>
        </div> 
        <div style={{height: '115px'}}>
        <textarea 
            value={noteContent}
            className='meeting-auditor-note-edit-content'
            onChange={(e) => setNoteContent(e.target.value)}
            autoFocus={noteContent.length === 0 ? true : false}
        />
        <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
            <button className='meeting-auditor-save-note' onClick={onSaveNote}>Save</button>
            <button className='meeting-auditor-delete-note' onClick={onDeleteNote}>Delete</button>
        </div>
        </div>
    </div>
}

const NotesComponent = (props) => {

    const dispatch = useDispatch();
    const notes = useSelector((state) => state['features/meeting-auditor'].auditorMessages);

    const [editNotes,setEditNotes] = useState([]);

    const createNewNote = async () => {
        const note = {
            content: ''
        }
        const res = await IISightAPI.createNote(
            {
                meeting_audit_note: {
                    meeting_audit_id: window.APP.meeting_audit_id,
                    note: note.content
                }

            });
        const { data: body } = res

        if(body.status)
            note.note_id = body.object.id
        note.id = (notes.length === 0) ? 1 : (notes[notes.length -1].id + 1);
        note.title =  "Note " + note.id;
        setEditNotes([...editNotes,note.id]);
        dispatch(addAuditMessages([...notes,note]));
    }

    return <div className='meeting-auditor-root'>
        <div className='meeting-auditor-header'>
            <div className='meeting-auditor-heading'>
                <IconAuditorNotesHeading className='meeting-auditor-heading-icon' style={{width: '40px',height: '40px'}} />
                <div className='meeting-auditor-heading-text'>Auditor Notes</div>
            </div>
            <IconAuditorNoteClose className='meeting-auditor-heading-close' style={{width: '24px',height: '24px',cursor: 'pointer'}} onClick={() => dispatch(setMessageListVisibility(false))}/>
        </div>
        <div className='meeting-auditor-notes-container'>
            <div className='meeting-auditor-bubble-container'>
                <div className='meeting-auditor-create-note-text' onClick={createNewNote}>+ Create a New Note</div>
            </div>
            {notes.map((note) => {
                if(editNotes.filter(id => note.id === id).length > 0)
                    return <NoteEditComponent note_id={note.note_id} id={note.id} title={note.title} content={note.content} editNotes={editNotes} setEditNotes={setEditNotes} notes={notes} dispatch={dispatch}/>
                else 
                    return <NoteShowComponent id={note.id} title={note.title} content={note.content} editNotes={editNotes} setEditNotes={setEditNotes}/>
            })}
        </div>
    </div>
}

export default NotesComponent;